(() => {
  'use strict';
  const pending = new WeakSet();
  const regroup = () => {
    document.querySelectorAll('#mib-wishlist-grid').forEach(grid => {
      const groups = new Map();
      const cards = [...grid.querySelectorAll('.mib-wishlist-card')];
      cards.forEach(card => {
        const key = card.querySelector('.ProductItem')?.dataset.productCardModelKey;
        card.hidden = false;
        if (!key) return;
        card.dataset.productCardModelKey = key;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(card);
      });
      groups.forEach(members => {
        const first = members[0];
        members.slice(1).forEach(card => { card.hidden = true; });
        const item = first.querySelector('.ProductItem');
        const id = item?.dataset.regiosDoppGenericProductId;
        const saved = members.find(card => card.dataset.mibProductId === id);
        const remove = first.querySelector('[data-mib-wishlist-remove]');
        if (!remove) return;
        remove.hidden = !saved;
        if (saved) {
          remove.dataset.mibProductId = saved.dataset.mibProductId;
          remove.dataset.mibVariantId = saved.dataset.mibVariantId;
        }
      });
      grid.dataset.productCardModels = String(cards.filter(card => !card.hidden).length);
    });
  };
  const upgrade = async (card) => {
    if (pending.has(card) || card.querySelector('.ProductItem')) return;
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    pending.add(card);
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      url.pathname = `${window.Shopify.routes.root}products/${url.pathname.split('/products/')[1]}`;
      url.searchParams.set('section_id', 'product-card-fragment');
      if (window.Shopify?.theme?.id) url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      const response = await fetch(url);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const item = html.querySelector('.ProductItem');
      if (!item || !card.isConnected) return;
      const remove = card.querySelector('[data-mib-wishlist-remove]');
      card.classList.add('mib-wishlist-card--shared');
      card.replaceChildren(item);
      window.initProductCardMedia?.(item);
      if (remove) card.append(remove);
      regroup();
      document.dispatchEvent(new CustomEvent('product-card:changed', { detail: { card: item } }));
    } catch { /* Keep the existing application card when its product cannot be loaded. */ }
  };
  const scan = (root) => {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.matches?.('.mib-wishlist-card')) void upgrade(root);
    root.querySelectorAll('.mib-wishlist-card').forEach(card => void upgrade(card));
  };
  const start = () => {
    scan(document);
    document.addEventListener('product-card:changed', regroup);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
      regroup();
    })
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
